import { Button, CircularProgress, Grid, Stack, Typography } from '@mui/material'
import DoneIcon from '@mui/icons-material/Done';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useForm } from 'react-hook-form'
import { useContext, useEffect, useState } from 'react'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { ControlledInput } from '../../components/forms/input/ControlledInput'
import { ControlledTextArea } from '../../components/forms/input/ControlledTextArea'
import { CancelModel } from '../../components/modal/CancelModal'
import { AppContext } from '../../contexts/AppContext';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import { toast } from 'react-toastify';

const LockerPenaltyForm = ({ selectedItem, setSelectedItem, open, setOpen, getMainValues, setMainValue, refetchData }: { selectedItem: any, setSelectedItem: (value: any) => void, open: boolean, setOpen: (value: boolean) => void, getMainValues: any, setMainValue: any, refetchData: any }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [chargePermission, setChargePermission] = useState(false)
    const { user } = useContext(AppContext)
    const { add } = useCrudForm()
    const cancelMessage = 'Cancel current unsaved changes and go back to locker charge management?'
    const { handleSubmit, control, setValue, getValues, formState: { errors, } } = useForm<valuesTypes>(
        {
            resolver: yupResolver(LockerPenaltySchema),
            defaultValues: { penalty: '', remarks: '' }
        })

    const onSubmit = () => {
        setIsLoading(true)
        add({
            endpoints: chargePermission ? endpoints.lockerCharge.deductPenalty({ lockerId: selectedItem?.lockerId, customerId: selectedItem?.customerId, penaltyAmount: getValues('penalty') })
                : endpoints.lockerCharge.updatePenalty,
            values: !chargePermission ? { id: selectedItem?.id, penaltyAmount: getValues('penalty'), remarks: getValues('remarks') } : null,
            onSuccess: (data: any) => {
                refetchData({})
                setIsLoading(false)
                setOpen(false)
                setSelectedItem(null)
                toast.success(data?.message, { style: { background: '#3150A1' } })
            },
            onError: (error: any) => {
                setIsLoading(false)
                toast.error(error?.message ?? error)
            }
        })
    };

    const handleClose = () => {
        setValue('penalty', '')
        setValue('remarks', '')
        setOpen(false);
        setSelectedItem(null)
    };

    useEffect(() => {
        if (selectedItem) {
            setChargePermission((user?.role)?.toLowerCase() === 'checker' ? true : false)
            setValue('penalty', selectedItem?.penalty)
            setValue('remarks', selectedItem?.remarks)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Typography component={'p'} mt={2} mb={2}>Charge Information</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6} >
                    <ControlledInput type="number" name={`penalty`} control={control} errors={errors} label="Penalty Charge" />
                </Grid>
                <Grid item xs={12} >
                    <ControlledTextArea name={`remarks`} control={control} errors={errors} label="Remarks" />
                </Grid>

            </Grid>
            <Stack direction='row' justifyContent='flex-end' spacing={3} mt={5}>
                <CancelModel handleModalClose={handleClose} message={cancelMessage} />
                <Button onClick={handleSubmit(onSubmit)} variant='contained' sx={{ color: '#3150A1' }} disabled={isLoading}>
                    <Stack direction='row' spacing={2}>
                        {
                            isLoading ? <CircularProgress size={20} color="inherit" /> : selectedItem ? <ModeEditIcon sx={{ color: 'white' }} /> : <DoneIcon sx={{ color: 'white' }} />
                        }
                        <Typography sx={{ color: isLoading ? 'gray' : 'white' }}>
                            {chargePermission ? 'Deduct' : 'Edit'}
                        </Typography>
                    </Stack>
                </Button>
            </Stack>
        </>
    )
}

export default LockerPenaltyForm

export type valuesTypes = {
    penalty: string,
    remarks: string
}

const LockerPenaltySchema = yup.object().shape({
    penalty: yup.number().required('Penalty is required').typeError('Penalty is required'),
    remarks: yup.string().nullable()
})